import React, { useState } from 'react'
import Chart from "react-apexcharts";
import CountUp from 'react-countup';
import { TransactionCards } from './Components/TransactionCardData';
import { myExpenseChart } from './Components/MyExpenseChart';
import { Link } from 'react-router-dom';

import CreditCardImg from "../../../assets/images/gallery/credit-card-img.png"
import AllTransactionTable from './Components/AllTransaction/AllTransactionTable';
import IncomeTable from './Components/IncomeTable/IncomeTabTable';
import ExpenseTable from './Components/Expense/ExpenseTable';

const Transaction = () => {

  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("transactions");

  return (
    <div>
      {/* x---------------------------------x Credit Card/Expence Section x---------------------------------x */}
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 xl:gap-4 lg:gap-2 md:gap-2 gap-2 justify-center`">
        {/* // x---------------------------------x Transaction Credit Card Section x---------------------------------xs */}
        {TransactionCards.map((cardData, index) => {
          return (
            <div key={index}>
              <div className={`${cardData.h_class} sm:p-2 xl:p-4`}>
                {cardData.id === 0 ? (
                  <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-dark sm:mb-0 mb-2">
                    {cardData.heading}
                  </h3>
                ) : (
                  <p className="text-right text-lg sm:text-xl md:text-2xl font-extrabold hidden sm:block text-primary hover:cursor-pointer" onClick={() => setOpen(!open)}>
                    + {cardData.heading}
                  </p>
                )}
              </div>
              <div className={`${cardData.id === 0 ? cardData.bg_color : "card-body"} rounded-2xl shadow-md overflow-hidden`}>
                <div className="mb-3">
                  <div className={`p-4 ${cardData.text_color}`}>
                    <div className="flex justify-between items-center">
                      <div>
                        <h5 className="text-base sm:text-lg font-normal">Balance</h5>
                        <h4 className={`text-2xl font-bold ${cardData.text_color}`}>
                          $ <CountUp
                            className={`${cardData.text_color}`}
                            end={cardData.value}
                            duration={2}
                          />
                        </h4>

                      </div>
                      <div className="card-img">{cardData.cardIcon}</div>
                    </div>
                    <div className="flex justify-between items-center py-4 sm:py-5 md:py-6">
                      <div>
                        <h5 className="text-base sm:text-lg font-normal mb-1">CARD HOLDER</h5>
                        <h4 className={`text-2xl font-bold ${cardData.text_color}`}>{cardData.name}</h4>
                      </div>
                      <div>
                        <h5 className="text-base sm:text-lg font-normal mb-1 text-opacity-75">VALID THRU</h5>
                        <h4 className={`text-2xl font-bold ${cardData.text_color}`}>{cardData.expiry}</h4>
                      </div>
                    </div>
                  </div>
                  <div className={`border-t border-dashed border-${cardData.borderColor} px-4 sm:px-6 md:px-8 mt-5`}>
                    <div className="flex justify-between items-center py-2 sm:py-3 md:py-4">
                      <div>
                        <h4 className={`text-2xl lg:text-3xl font-bold ${cardData.text_color}`}>{cardData.cardNumber}</h4>
                      </div>
                      <div>{cardData.f_icon}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* // x---------------------------------x My Expence Section x---------------------------------x */}
        <div className="card border-none h-full">
          <div className="card-header mb-4">
            <h3 className="text-dark  text-lg sm:text-xl md:text-2xl font-semibold">My Expense</h3>
          </div>
          <div className="card-body rounded-2xl mb-3 sm:mb-0 bg-light sm:p-9 pt-3">
            <div id="chart">
              <Chart
                options={myExpenseChart}
                series={myExpenseChart.series}
                type={myExpenseChart.chart.type}
                height={myExpenseChart.chart.height}
              />
            </div>
          </div>
        </div>
      </div>

      {/* // x---------------------------------x Recent Transactions Section x---------------------------------x */}
      <div className="flex my-2">
        <div className="w-full">
          <div className="card border-0 bg-transparent h-100">
            <div className="card-header justify-between mb-4">
              <h3 className="text-dark text-lg sm:text-xl md:text-2xl font-semibold">Recent Transactions</h3>
            </div>
            <div className="card-body rounded-2xl p-2 mb-3 mb-sm-0">
              {/* x---------------------------------x Tab Navigation x---------------------------------x */}
              <div className="border-b border-[var(--light-bg6)] dark:border-neutral-700" >
                <nav className="flex gap-x-1 sm:flex-row flex-col" aria-label="Tabs" role="tablist" >
                  <button
                    type="button"
                    className={`font-semibold py-2 px-2 inline-flex items-center gap-x-2 border-b-[3px] border-transparent whitespace-nowrap text-gray-500 hover:text-primary hover:border-primary focus:outline-none focus:text-primary ${activeTab === 'transactions' ? 'tab_active' : ''}`}
                    onClick={() => setActiveTab('transactions')}
                    aria-selected={activeTab === 'transactions'}
                    role="tab"
                  >
                    All Transactions
                  </button>

                  <button
                    type="button"
                    className={`font-semibold py-2 px-2 inline-flex items-center gap-x-2 border-b-[3px] border-transparent whitespace-nowrap text-gray-500 hover:text-primary hover:border-primary focus:outline-none focus:text-primary ${activeTab === 'income' ? 'tab_active' : ''}`}
                    onClick={() => setActiveTab('income')}
                    aria-selected={activeTab === 'income'}
                    role="tab"
                  >
                    Income
                  </button>

                  <button
                    type="button"
                    className={`font-semibold py-2 px-2 inline-flex items-center gap-x-2 border-b-[3px] border-transparent whitespace-nowrap text-gray-500 hover:text-primary hover:border-primary focus:outline-none focus:text-primary ${activeTab === 'expense' ? 'tab_active' : ''}`}
                    onClick={() => setActiveTab('expense')}
                    aria-selected={activeTab === 'expense'}
                    role="tab"
                  >
                    Expense
                  </button>
                </nav>
              </div>

              {/* x---------------------------------x Tab Content x---------------------------------x */}
              <div className="mt-3">
                {activeTab === 'transactions' && (
                  <div id="tabs-transactions" role="tabpanel">
                    <AllTransactionTable />
                  </div>
                )}

                {activeTab === 'income' && (
                  <div id="tabs-income" role="tabpanel">
                    <IncomeTable />
                  </div>
                )}

                {activeTab === 'expense' && (
                  <div id="tabs-expense" role="tabpanel">
                    <ExpenseTable />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* // x---------------------------------x Add Cards offcanvas x---------------------------------x */}
      <div
        id="offcanvasRight hs-offcanvas-body-scrolling-with-backdrop"
        className={`hs-overlay [--body-scroll:true] hs-overlay-open:translate-x-0 fixed top-0 right-0 transition-all duration-300 transform h-full max-w-md w-full z-50 bg-body text-dark shadow-lg ${open ? 'translate-x-0 block' : 'translate-x-full hidden'}`}
        role="dialog"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="flex justify-between items-center py-3 px-4">
          <h5 id="offcanvasRightLabel" className="font-bold ">Add Card</h5>
          <button type="button" className="size-8 inline-flex justify-center items-center gap-x-2 rounded-full bg-primary-100 hover:bg-primary-200 focus:outline-none" aria-label="Close" onClick={() => setOpen(false)}>
            <span className="sr-only">Close</span>
            <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>

        <div className="p-4">
          <div className="mb-3">
            <div className="flex flex-col">
              <div className="w-full">
                <img src={CreditCardImg} alt="Trendy Pants and Shoes" className=" rounded" />
              </div>
              <div className="mt-4">
                <h5 className="font-bold ">Benefits that Work for You</h5>
                <p className=" mt-2">
                  This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.
                </p>
                <Link to="/Credit-cards" className="mt-4 inline-block bg-primary-800 text-white font-medium py-2 px-4 rounded-lg hover:bg-primary-900">Add Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Transaction;

